import { Link } from "react-router-dom";
import { useRecoilValue } from "recoil";

import { userAtom } from "../../services/atoms/auth.atoms";
import { SidebarMenuCard } from "../../types/types";
import { ROUTES } from "../../helpers/constants";

interface props {
  card: SidebarMenuCard;
}

export const SidebarMenuCardComponent: React.FC<props> = ({ card }) => {
  const userData = useRecoilValue(userAtom);
  return (
    // <Link to={ROUTES.PROFILE.route} className='gm-sidebar-card-component'>
    <div className='gm-sidebar-card-component'>
      <img className="gm-card-image" src='https://cdn-icons-png.flaticon.com/512/149/149071.png' alt='gm-profile-img' />
        <div className='gm-card-profile-info'>
          <div className="gm-card-name">{userData?.data.displayName}</div>
          <div className="gm-card-group">{card.group}</div>
        <div className="gm-card-role">{userData?.data.role}</div>
      </div>
    </div>

    //</Link>
  )
};
